<template >
  <div class="relative py-16" style="margin: 0 10%;" id="over-ons">
    <!-- Header -->
    <div class="text-center mb-12 relative z-20">
      <h2 class="text-4xl lg:text-5xl font-bold text-gray-800 mb-4">Over Ons</h2>
      <p class="text-lg text-gray-600">
        Leer meer over onze passie voor verse vis, duurzaamheid en waarom onze klanten ons vertrouwen.
      </p>
    </div>

    <!-- Grid Layout -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start justify-items-center">
      <!-- Tekstgedeelte -->
      <div class="space-y-6 lg:pr-12 relative z-20">
        <h3 class="text-3xl font-semibold text-sky-600">Wie zijn wij?</h3>
        <p class="text-gray-700 text-lg leading-relaxed">
          De naam <span class="font-bold">van Wijk</span> is niet onbekend in de viswereld.<br>
          Vanaf klein jongetje mocht ik al mee helpen in de visgroothandel van mijn opa en vader. Ooit een eigen visspeciaalzaak openen is altijd al een grote droom geweest.
        </p>
        <p class="text-gray-700 text-lg leading-relaxed">
          Naast de vele soorten verse vis, bieden wij u ook huisgemaakte maaltijden, soepen, verschillende schotels en natuurlijk ook haring en heerlijke gebakken vis.<br>
          Wij maken gebruik van zo veel mogelijk duurzame verpakkingen. Dit is van ons een bewuste keuze omdat we niet willen dat er nog meer plastic in de zee terecht komt.<br>

        </p>
        <h3 class="text-3xl font-semibold text-sky-600">Waar kunt u ons vinden?</h3>
        <p class="text-gray-700 text-lg leading-relaxed">
          U kunt ons vinden in Winkelcentrum de Heyhoef. Het gezellige winkelcentrum organiseert vele leuke festiviteiten en is goed bereikbaar met veel gratis parkeergelegenheid.
          Graag ontvangen we u snel in onze winkel. Tot dan!
        </p>
        <p class="text-gray-700 text-lg leading-relaxed">
          Willem & Kim
        </p>

        
      </div>

      <!-- Afbeeldingen Grid -->
      <div class="relative z-10 mt-4">
        <!-- Grote Afbeelding -->
        <div class="relative w-11/12 mx-auto">
          <img
            src="/Willemkim2.jpeg"
            alt="Onze Vis"
            class="rounded-xl shadow-lg w-full h-auto transform scale-100 hover:scale-105 transition"
          />
        </div>
        <!-- Kleine Overlappende Afbeelding -->
        <div class="absolute top-[-50px] right-[-50px] hidden xl:block w-40 h-40">
          <img
            src="oyster.jpg"
            alt="Duurzaamheid"
            class="rounded-xl shadow-md w-full h-full object-cover transform rotate-3 scale-95 hover:scale-100 transition"
          />
        </div>
        <!-- Tweede Overlappende Afbeelding -->
        <div class="absolute bottom-[-50px] left-[-50px] hidden xl:block w-48 h-48">
          <img
            src="crab.jpg"
            alt="Versheid"
            class="rounded-xl shadow-md w-full h-full object-cover transform -rotate-3 scale-95 hover:scale-100 transition"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
};
</script>

<style scoped>
/* Zorg dat overlappende afbeeldingen zichtbaar blijven */
@media (max-width: 1024px) {
  .absolute {
    position: static !important;
    transform: none !important;
  }
}
</style>
